<div class="container">
  <div class="error-box">
    <div style="font-size: 2.5rem; margin-bottom: 1rem">
      <strong>Checkout Failed!</strong>
    </div>
    <strong> An error occured while executing your checkout request, please try again later. </strong>
  </div>
</div>
